import { render, staticRenderFns } from "./favicon-upload.vue?vue&type=template&id=89da77ca&scoped=true&"
import script from "./favicon-upload.vue?vue&type=script&lang=js&"
export * from "./favicon-upload.vue?vue&type=script&lang=js&"
import style0 from "./favicon-upload.vue?vue&type=style&index=0&id=89da77ca&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89da77ca",
  null
  
)

export default component.exports